var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('span',{staticClass:"not-found-wrapper"},[_c('div',{staticClass:"not-found-icon"},[_c('v-icon',{attrs:{"size":"200"}},[_vm._v("mdi-robot-dead-outline")]),_c('p',[_vm._v("400")])],1),_c('button',{staticClass:"confirmar-btn"},[_vm._v("voltar")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }